import { PERMS } from '@/config/permissions';
import DefaultLayout from '@/layouts/DefaultLayout.vue';

const UserList = () => import('@/modules/system/user/UserList.vue');
const RoleList = () => import('@/modules/system/role/RoleList.vue');
const OperationLog = () => import('@/modules/system/log/OperationLog.vue');

export const systemRoutes = {
  path: '/system',
  name: 'System',
  component: DefaultLayout,
  meta: {
    title: '系统管理',
    titleKey: 'route.system',
    icon: 'Setting',
    order: 6,
  },
  children: [
    {
      path: 'users',
      name: 'Users',
      component: UserList,
      meta: {
        title: '用户管理',
        titleKey: 'route.users',
        icon: 'user',
        order: 10,
        permissions: [PERMS.USER_VIEW],
      },
    },
    {
      path: 'roles',
      name: 'Roles',
      component: RoleList,
      meta: {
        title: '角色管理',
        titleKey: 'route.roles',
        icon: 'team',
        order: 11,
        permissions: [PERMS.ROLE_VIEW],
      },
    },
    {
      path: 'logs',
      name: 'Logs',
      component: OperationLog,
      meta: {
        title: '操作日志',
        titleKey: 'route.logs',
        icon: 'file-search',
        order: 12,
        permissions: [PERMS.LOG_VIEW],
      },
    },
  ],
};
